// Pieces shared by the Penyedia work tools: the section frame (an h2 with
// its lead), the count tiles, the labels of the requirement categories and
// statuses, and the number parsing of the editable tables.
import type { ReactNode } from "react";
import type { RequirementCategory, RequirementStatus } from "./api";

export const CATEGORY_LABEL: Record<RequirementCategory, string> = {
  administrasi: "Administrasi",
  kualifikasi: "Kualifikasi",
  teknis: "Teknis",
  harga: "Harga",
  lainnya: "Perlu klasifikasi",
};

export const CATEGORIES = Object.keys(CATEGORY_LABEL) as RequirementCategory[];

export const STATUS_LABEL: Record<RequirementStatus, string> = {
  belum_diperiksa: "Belum diperiksa",
  sesuai: "Sesuai",
  belum_sesuai: "Belum sesuai",
  tidak_berlaku: "Tidak berlaku",
};

export const STATUSES = Object.keys(STATUS_LABEL) as RequirementStatus[];

/** One work tool: a titled region with its lead and an optional action at the end of the head. */
export function WorkSection({ id, title, lead, action, children }: { id: string; title: string; lead: ReactNode; action?: ReactNode; children: ReactNode }) {
  return (
    <section className="wk" aria-labelledby={`${id}-title`} data-tool={id}>
      <div className="wk-head">
        <div className="wk-head-text">
          <h2 id={`${id}-title`} className="wk-title">
            {title}
          </h2>
          <p className="wk-lead">{lead}</p>
        </div>
        {action ? <div className="wk-head-action">{action}</div> : null}
      </div>
      {children}
    </section>
  );
}

export function CountTiles({ label, tiles }: { label: string; tiles: { label: string; value: ReactNode; note?: string }[] }) {
  return (
    <dl className="wk-counts" aria-label={label}>
      {tiles.map((t) => (
        <div key={t.label} className="wk-count">
          <dt className="wk-count-label">{t.label}</dt>
          <dd className="wk-count-value num">{t.value}</dd>
          {t.note ? <dd className="wk-count-note">{t.note}</dd> : null}
        </div>
      ))}
    </dl>
  );
}

/** A typed number: comma or dot decimals, thousands dots dropped when there is a comma; NaN when not a number. */
export function parseNumber(value: string): number {
  const trimmed = value.trim().replace(/\s/g, "");
  if (!trimmed) return Number.NaN;
  const normalized = trimmed.includes(",") ? trimmed.replace(/\./g, "").replace(",", ".") : trimmed;
  return /^-?\d*(\.\d+)?$/.test(normalized) ? Number(normalized) : Number.NaN;
}

/** Rupiah amounts to the cent, the same rounding as the API. */
export function cents(value: number): number {
  return Math.round(value * 100) / 100;
}

let seq = 0;
/** A local key for a row that has no server id yet. */
export function localKey(): string {
  seq += 1;
  return `baru-${seq}`;
}
